import commonMapping from "@/mapping/common";

export const setPassword = {
  username: commonMapping.dniEncrypt,
  old_http_passwd: commonMapping.dniEncrypt,
  new_http_passwd: commonMapping.dniEncrypt,
  confirm_http_passwd: commonMapping.dniEncrypt,
  enable_password_recovery: commonMapping.intToBoolean,
  pwd_question1: commonMapping.question1List,
  pwd_question2: commonMapping.question2List,
  pwd_answer1: commonMapping.pwdEncrypt,
  pwd_answer2: commonMapping.pwdEncrypt,
};

export default setPassword;
